import api from "../../utils/apiUser";

export const getMeAdmin = async () => {
  const res = await api.get("/api/acceso/me");
  return res.data;
};
